import { Component, effect } from '@angular/core';
import { MessageService, SelectItem, ConfirmationService } from 'primeng/api';
import { Parcel } from '../../shared/models/parcel';
import { ParcelService } from '../../shared/services/parcel.service';
import { ImageItem } from '../../shared/models/unassigned';
import { DataService } from '../../shared/services/data.service';
import { environment as env } from '../../../environments/environment';
import { TablePageEvent } from 'primeng/table';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { ParcelDetailComponent } from "../parcel-detail/parcel-detail.component";
import { DashboardFiltersComponent } from "../dashboard-filters/dashboard-filters.component";


@Component({
  selector: 'app-unassigned',
  templateUrl: './unassigned.component.html',
  styleUrl: './unassigned.component.scss',
  standalone:true,
  imports: [...PRIMENG_MODULES, SpinnerComponent, ParcelDetailComponent, DashboardFiltersComponent]
})
export class UnassignedComponent {
  isLoading: boolean = false;
  selectedItems: ImageItem[] = [];
  users: string[] = [];
  sortField!: string;
  isSelectAllChecked: boolean = false;
  unassignedItems: ImageItem[] = [];
  dateRange: any;
  selectedCamera: string = '';
  selectedItemCode: string = '';
  bulkUpdateUserId: string = '';
  bulkUpdateLimit: number = env.bulkUpdateLimit;
  currentUser: string | undefined;
  displayDialog: boolean = false;

  cameraList = this.parcelService.getCameraList();
  itemCodes = this.parcelService.getItemCodes();

  selectedRow: Parcel[] = [];
  recordNotFound = false;
  searchParcel: any;
  filterOptions = {
    showCameraFilter: true,
    showItemCodeFilter: true,
    showDateRangeFilter: true,
    showApplyButton: true,
    showClearFilterButton: true,
    showSearchParcel: true
  }
  singleSelections = true;
  itemsFromSingleSelections: any[] = [];

  rowsPerPage: any;
  enableClose: boolean = true;
  BulkUsersList: string[] = [];
  constructor(private parcelService: ParcelService,
    private dataService: DataService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {
    effect(() => {
      this.currentUser = this.dataService.currentDataSignal();
    });
  }

  ngOnInit() {
    this.getUserDetails();
    this.getUnassigned();
  }

  getUserDetails() {
    this.parcelService.getUsers().subscribe(
      result => {
        this.users = result.users;
        this.BulkUsersList = [...result.users];
        this.BulkUsersList.sort((a,b)=>{
          if (a === this.currentUser) return -1;
          if (b === this.currentUser) return 1;
          return a.localeCompare(b);
        })
      }
    )
  }

  getUnassigned(queryString?: string) {
    this.isLoading = true
    this.parcelService.getUnassigned(queryString).subscribe({
      next: (result) => {
        this.isLoading = false;
        if (result?.result?.Items) {
          this.unassignedItems = result.result.Items.map((item: any) => this.transformItem(item));
        } else {
          console.warn('No data received');
          this.unassignedItems = [];
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Error fetching unassigned parcels:', err);
        this.unassignedItems = [];
      }
    });
  }

  applySearch(): void {
    this.resetTable();
    let queryString = '';

    if (this.selectedCamera) {
      queryString += `&captureDeviceId=${this.selectedCamera}`;
    }

    if (this.selectedItemCode) {
      queryString += `&itemCode=${this.selectedItemCode}`;
    }

    if (this.dateRange && this.dateRange.length > 0) {
      const dateFrom = this.dateRange[0]?.getTime();
      const dateTo = this.dateRange[1]?.getTime();

      if (dateFrom && dateTo) {
        queryString += `&dateFrom=${dateFrom}&dateTo=${dateTo}`;
      }
    }

    if (this.searchParcel) {
      queryString += `&itemId=${this.searchParcel}`;
    }

    this.getUnassigned(queryString);
  }


  onParcelClick(event: MouseEvent, parcel: any): void {
    event.preventDefault();
    this.recordNotFound = false;
    this.selectedRow = parcel;
    this.displayDialog = true;
  }


  handleRecordNotFound() {
    this.recordNotFound = true;
  }

  resetModalState() {
    this.selectedRow = [];
    this.recordNotFound = false;
  }

  onApiSuccessFromModal() {
    this.applySearch();
    this.displayDialog = false;
  }

  private resetTable(): void {
    this.selectedItems = [];
    this.bulkUpdateUserId = '';
    this.unassignedItems = [];
    this.itemsFromSingleSelections = [];
  }

  private transformItem(raw: any): ImageItem {
    return {
      captureDeviceId: raw['capturedevice-id'],
      imageNames: raw['image-names'],
      userId: raw['userId'],
      status: raw['status'],
      timestamp: raw['timestamp'],
      imageDatetimes: raw['image-datetimes'],
      itemId: raw['itemId'],
      locationId: raw['location-id'],
    };
  }

  receiveFilterApplied(params: any) {
    this.selectedCamera = params.selectedCamera;
    this.selectedItemCode = params.selectedItemCode;
    this.dateRange = params.dateRange;
    this.searchParcel = params.searchParcel;

    this.applySearch();
  }
  receiveClearFilter() {
    this.selectedCamera = '';
    this.selectedItemCode = '';
    this.dateRange = [];
    this.searchParcel = '';
    this.applySearch();
  }
  onParcelAssigneeSelection(item: any = []) {

    const index = this.itemsFromSingleSelections.findIndex(parcel => parcel.itemId === item.itemId);

    if (index !== -1) {
      this.itemsFromSingleSelections[index] = item;
    } else {
      this.itemsFromSingleSelections.push(item);
    }
    this.itemsFromSingleSelections = this.itemsFromSingleSelections.filter(item => item.selectedUser);
  }

  onAssign() {
    let itemsToAssign = [];

    if (this.selectedItems.length > 0 && !this.singleSelections) {
      itemsToAssign = this.selectedItems;

    } else {
      itemsToAssign = this.itemsFromSingleSelections;

    }

    if (itemsToAssign.length > 0) {
      let parcels = itemsToAssign.slice(0, this.bulkUpdateLimit).map(item => ({
        itemId: item.itemId,
        userId: this.selectedItems.length > 0 ? this.bulkUpdateUserId : item.selectedUser,
        status: "assigned",
        updater: this.currentUser
      }));

      this.isLoading = true;

      this.parcelService.bulkAssignParcel(parcels).subscribe({
        next: () => {
          let message = (itemsToAssign.length > this.bulkUpdateLimit) ? `only first ${this.bulkUpdateLimit} selected` : parcels.length.toString();
          this.messageService.add({
            severity: 'success',
            summary: 'Row Submitted',
            detail: `Successfully submitted: ${message} rows`
          });
          this.isLoading = false;
          this.applySearch();

        },
        error: (err) => {
          console.error(`Failed to bulk update`, err);
          this.isLoading = false;
        }
      });
    }
  }
  getToolTipFormattedText() {
    return (this.selectedItems.length != 0 || this.itemsFromSingleSelections.length != 0) ? `${this.selectedItems.length > 0 ? this.selectedItems.length : this.itemsFromSingleSelections.length} of ${this.unassignedItems.length} parcels selected to assign` : '';
  }
  checkSelection() {
    this.singleSelections = false;
    this.bulkUpdateUserId = this.selectedItems.length == 0 ? '' : this.bulkUpdateUserId;
    if (this.selectedItems.length > this.bulkUpdateLimit) {
      this.enableClose = false;
      this.confirmationService.confirm({
        header: 'Limit exceeded',
        message: `You've reached the assigning limit ${this.bulkUpdateLimit}`,
        icon: 'pi pi pi-exclamation-circle text-6xl text-primary-500 mr-4',
        acceptIcon: 'pi pi-check mr-2',
        acceptLabel: 'Ok',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        rejectVisible: false,
        closeOnEscape: false,
        accept: () => {
          this.selectedItems = this.selectedItems.slice(0, this.bulkUpdateLimit);
        }
      });
    }
  }
  onPageChange($event: TablePageEvent) {
    let prevRowsPerPage = this.bulkUpdateLimit
    this.bulkUpdateLimit = $event.rows
    if (this.bulkUpdateLimit < prevRowsPerPage)
      this.checkSelection()
  }
}
